module.exports = __webpack_public_path__ + "img/sleep.613c83a5.svg";